<template>
    <v-layout justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%" class="shop-product-view">
            <div class="headline text-start mt-8">업체 상세</div>

            <info-basic v-model="user" @showOverlay="showOverlay" />
            <info-status v-model="user" @saveScope="saveScope" />
            <info-detail v-model="user" />
            <info-description v-model="user" />

            <v-btn v-if="isCompany" bottom color="accent" fixed right @click="saveElse"> <v-icon class="mr-2">mdi-content-save</v-icon> 수정사항 저장 </v-btn>

            <v-overlay v-if="overlay.show">
                <v-img :src="overlay.item" @click="hideOverlay()" v-click-outside="hideOverlay" contain max-width="80vw" max-height="80vh" />
            </v-overlay>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import InfoBasic from "@/components/console/company/company-view/info-basic.vue";
import InfoDetail from "@/components/console/company/company-view/info-detail.vue";
import InfoStatus from "@/components/console/company/company-view/info-status.vue";
import InfoDescription from "@/components/console/company/company-view/info-description.vue";

export default {
    components: { InfoBasic, InfoDetail, InfoStatus, InfoDescription },
    data() {
        return {
            user: undefined,
            overlay: {
                show: false,
                item: undefined,
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                const _id = this.$route.params._user;
                if (!this.isConsole && this.payload._user !== _id) {
                    this.$router.replace(`/console/company/${this.payload._user}`);
                    this.init();
                } else {
                    var { user } = await api.console.users.getUser({ _id });
                    this.user = user;
                }
            } catch (error) {
                console.error(error);
            }
        },

        showOverlay(item) {
            this.overlay = { show: true, item };
        },

        hideOverlay() {
            this.overlay = { show: false, item: undefined };
        },

        async saveScope() {
            try {
                const { _id, scope } = this.user;
                await api.console.users.putUser({ _id, scope });
            } catch (error) {
                this.handleError(error);
            }
        },

        async saveElse() {
            const { scope, ...user } = this.user;
            try {
                await api.console.users.putUser(user);
                alert("정보가 수정되었습니다");
            } catch (error) {
                this.handleError(error);
            }
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        isConsole() {
            return this.scope.includes("console");
        },
        isCompany() {
            return this.$store.state.payload._user == this.$route.params._user;
        },
    },
};
</script>
